<template>
    <Designer />
</template>

<script>
// @ is an alias to /src
import Designer from '@/components/Designer.vue'

export default {
  name: 'Create',
  components: {
    Designer
  },
  mounted() {
    // this.$analytics.logEvent("page_view");
    // this.$analytics.logEvent("screen_view", {
    //  screen_name: 'create',
    // });
  },
}
</script>
